import { ITableColumnMetadata } from '../../components/CustomTable/interfaces';

const tableColumnMetadata: ITableColumnMetadata[] = [
  { key: 'code', displayName: 'Código' },
  { key: 'unit.name', displayName: 'Unidad' },
  { key: 'customer.business.ruc', displayName: 'RUC' },
  { key: 'customer.business.name', displayName: 'Empresa' },
  { key: 'customer.name', displayName: 'Cliente' },
  { key: 'customer.email', displayName: 'Correo electrónico' },
  { key: 'creationDate', displayName: 'Fecha de creación', type: 'date' },
  { key: 'finishDate', displayName: 'Fecha de cierre', type: 'date' },
  { key: 'manager.name', displayName: 'Responsable' },
  {
    key: 'status',
    displayName: 'Estado',
    type: 'status',
    statusMap: {
      WAITING: { text: 'En espera', background: 'warning' },
      CLOSED: { text: 'Resuelto', background: 'success' },
      EXECUTING: { text: 'En ejecución', background: 'danger' }
    }
  }
];

export default tableColumnMetadata;
